import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Bars3Icon,
  XMarkIcon,
  Squares2X2Icon,
  UsersIcon,
  PuzzlePieceIcon,
  ClipboardDocumentListIcon,
  ClipboardDocumentCheckIcon,
  ClockIcon,
  BellIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import logo from '../../assets/logo.svg'

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: Squares2X2Icon },
  { to: "/user", label: "Users", icon: UsersIcon },
  { to: "/games", label: "Games", icon: PuzzlePieceIcon },
  { to: "/game-plan", label: "Game Plan", icon: ClipboardDocumentListIcon },
  { to: "/tasks", label: "Tasks", icon: ClipboardDocumentCheckIcon },
  { to: "/history", label: "History", icon: ClockIcon },
  { to: "/notifications", label: "Notification", icon: BellIcon },
  { to: "/settings", label: "Settings", icon: Cog6ToothIcon },
];

const Sidebar = () => {
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const linksMarkup = (
    <ul className="space-y-2">
      {navItems.map(({ to, label, icon: Icon }) => {
        const active = pathname.startsWith(to);
        return (
          <li key={to}>
            <Link
              to={to}
              onClick={() => setMobileOpen(false)}
              className={`flex items-center gap-3 py-3 px-4 rounded-lg transition ${
                active
                  ? "bg-brand text-white"
                  : "bg-gray-900 text-gray-300 hover:bg-gray-700 hover:text-white"
              }`}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span>{label}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      {/* Mobile top bar */}
      <div className="md:hidden flex items-center justify-between bg-gray-800 text-white px-4 py-3">
        <img src={logo} className="h-7" alt="Admin Panel" />
        <button
          onClick={() => setMobileOpen(true)}
          className="p-2 rounded-lg hover:bg-gray-700"
          aria-label="Open menu"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>
      </div>

      {/* Desktop sidebar */}
      <div className="hidden md:flex w-64 shrink-0 bg-gray-800 text-white p-6 flex-col">
        <h2 className="mb-6 mx-auto">
          <img src={logo} className="h-8" alt="Admin Panel" />
        </h2>
        {linksMarkup}
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50 flex">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setMobileOpen(false)}
          />
          <div className="relative w-64 bg-gray-800 text-white p-6 flex flex-col">
            <div className="mb-6 flex items-center justify-between">
              <img src={logo} className="h-8" alt="Admin Panel" />
              <button
                onClick={() => setMobileOpen(false)}
                className="p-1 rounded-lg hover:bg-gray-700"
                aria-label="Close menu"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            {linksMarkup}
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;